import styled, { createGlobalStyle } from 'styled-components';

export const CheckboxGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;

    @media (min-width: 768px) {
        flex-direction: column;
        gap: 12px;
    }

    .ant-form-item {
        margin-bottom: 0 !important;
    }

    .ant-checkbox-wrapper {
        display: flex;
        align-items: flex-start;
        word-break: break-word;
        line-height: 1.4;
    }
`;

export const FormContainer = styled.div`
    margin-bottom: var(--spacing-small);
    margin-top: var(--spacing-small);
    width: 100%;
`;

// Classe global para estilizar o texto dos termos usando CSS Variables do tema
export const TermsTextStyle = createGlobalStyle`
  .terms-text {
    font-weight: var(--terms-text-font-weight-fml);
    color: var(--terms-text-color-fml);
  }
`;
